/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirmupgrade1Inputs */

const en_confirmupgrade1 = /** @type {(inputs: Confirmupgrade1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm Upgrade`)
};

const de_confirmupgrade1 = /** @type {(inputs: Confirmupgrade1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wechsel bestätigen`)
};

/**
* | output |
* | --- |
* | "Confirm Upgrade" |
*
* @param {Confirmupgrade1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const confirmupgrade1 = /** @type {((inputs?: Confirmupgrade1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirmupgrade1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confirmupgrade1(inputs)
	return de_confirmupgrade1(inputs)
});
export { confirmupgrade1 as "confirmUpgrade" }